import React from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

// Manager's shift note, readable on the shift card itself.
const ShiftNoteInline = ({ note, maxLines }) => {
  if (!note) {
    return null;
  }

  // Tailwind 3.1 has no line-clamp utility
  const clampStyle = maxLines
    ? {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: maxLines,
        overflow: "hidden",
      }
    : undefined;

  return (
    <div className="mt-3 flex flex-row items-start rounded-lg bg-violet-100 px-2.5 py-2">
      <div className="mr-2 text-violet-600 flex items-center h-4">
        <ChatBubbleOutlineIcon sx={{ fontSize: 15 }} />
      </div>
      <p
        className="flex-1 min-w-0 text-xs leading-4 text-violet-900 whitespace-pre-line break-words"
        style={clampStyle}
      >
        {note}
      </p>
    </div>
  );
};

export default ShiftNoteInline;
